export enum BrowserPermission {
    Geolocation = 'geolocation',
    Camera = 'camera',
    Microphone = 'microphone',
    Notifications = 'notifications',
    Midi = 'midi',
    Push = 'push',
    Clipboardread = 'clipboard-read',
    Clipboardwrite = 'clipboard-write',
    Paymenthandler = 'payment-handler',
    Usb = 'usb',
    Bluetooth = 'bluetooth',
    Accelerometer = 'accelerometer',
    Gyroscope = 'gyroscope',
    Magnetometer = 'magnetometer',
    Ambientlightsensor = 'ambient-light-sensor',
    Backgroundsync = 'background-sync',
    Persistentstorage = 'persistent-storage',
    Screenwakelock = 'screen-wake-lock',
    Webshare = 'web-share',
    Xrspatialtracking = 'xr-spatial-tracking',
}
